import { useEffect, useState } from 'react';

// Detecta se a viewport está em modo mobile (<= breakpoint). Default 640px.
export function useIsMobile(breakpoint = 640) {
  const get = () => (typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false);
  const [isMobile, setIsMobile] = useState(get);
  useEffect(() => {
    const handler = () => setIsMobile(get());
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [breakpoint]);
  return isMobile;
}
